(function init() {
  const element = document.querySelector('#NavDrawer');
  const toggle = document.querySelector('.js-drawer-open-left-link');

  function deactivateFocusTrap(menu) {
    // set css property of visibility to hidden on 'element'
    element.style.visibility = 'hidden';
    menu.active = false;
    menu.trap.deactivate();

    // Show page content
    const mainContent = document.querySelectorAll('header, nav, main, footer');

    mainContent.forEach((el) => {
      el.setAttribute('aria-hidden', false);
      el.style.opacity = '1';
      el.style.visibility = 'visible';
    });
  }

  function activateFocusTrap(menu) {
    const mainContent = document.querySelectorAll('header, nav, main, footer');
    // set css property of visibility to visible on 'element'
    element.style.visibility = 'visible';
    menu.trap.activate();
    menu.active = true;

    // Hide page content
    mainContent.forEach((el) => {
      el.setAttribute('aria-hidden', true);
      el.style.opacity = '0';
      el.style.transition = 'all 0.35s ease-in-out';
      el.style.visibility = 'hidden';
    });
  }

  function initFocusTrap() {
    const m = { element, active: false };
    const trap = window.focusTrap.createFocusTrap(element, {
      clickOutsideDeactivates: true,
      escapeDeactivates: true,
      initialFocus: () => element.querySelector('.mobile-nav__link'),
      onActivate: () => {
        activateFocusTrap({ ...m, trap });
      },
      onDeactivate: () => {
        deactivateFocusTrap({ ...m, trap });
      },
    });

    return { element, active: false, trap };
  }

  toggle.addEventListener('click', (e) => {
    e.preventDefault();
    activateFocusTrap(initFocusTrap());

    const closeBtn = element.querySelector('.mobile-menu--close-btn');

    if (closeBtn) {
      closeBtn.addEventListener('click', (e) => {
        e.preventDefault();
        deactivateFocusTrap(initFocusTrap());
      });
    }
  });
})();
